<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="card border border-secondary">
                    <div class="card-body text-secondary">
                        <button id="btnAddBillingAddress" class="btn btn-primary float-right " @click="onAddBillingAddressClick" v-show="!billingAddress">
                            Add Billing Address
                        </button>
                        <h5 class="card-title text-secondary">Billing Address</h5>
                        <!-- <div class="mb-5 w-100">
                            <button class="btn btn-primary float-right " @click="onAddBillingAddressClick">Add Billing Address</button>
                        </div> -->
                        <p v-if="!loadingBillingAddress">
                            <span v-if="billingAddress">
                                {{ billingAddress.siteName }}<br>
                                {{ billingAddress.streetAddress }}<br>
                                {{ billingAddress.city }} <br>
                                {{ billingAddress.province }} <br>
                                {{ billingAddress.postalCode }}<br>
<!--                                {{ billingAddress.country }}-->
                            </span>
                            <span v-else>
                                No billing address found.
                            </span>
                        </p>
                        <p v-show="loadingBillingAddress">Loading...</p>
                        <button id="btnEditBillingAddress" class="btn btn-primary float-right " @click="onEditBillingAddressClick" v-show="billingAddress">
                           Edit
                        </button>
                    </div>
                </div>
                <hr>
                <div v-show="canHaveShippingAddresses">
                    <h5>Shipping Addresses</h5>
                    <div class="mb-5 w-100">
                        <button id="btnAddShippingAddress" class="btn btn-primary float-right " @click="onShippingAddressAddClick">Add Shipping Address</button>
                    </div>
                    <div v-if="!loading">
                        <data-table :headings="shippingAddressHeadings"
                                    :data="shippingAddresses"
                                    :hasActions="true"
                                    :stateChanged="filterStateChanged"
                                    :pagingDetails="pagingDetails"
                                    @actionClicked="onShippingAddressActionClicked"
                                    @filterSearchClicked="onFilterSearchClicked">
                            <template #filter>
                                <div class="p-3">
                                    <div class="input-group pb-4">
                                        <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="shippingAddressFilter.searchQuery">
                                        <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                        </div>
                                    </div>
                                    <active-inactive-radio-buttons :activeInactiveKey="shippingAddressFilter.activeOrInactiveItems"
                                                                   :componentId="'customerFilterRadioButtons'"
                                                                   @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                                </div>
                            </template>
                        </data-table>
                    </div>
                </div>
                
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <modal-form
                :heading="billingAddressModal.heading" 
                :modalId="billingAddressModal.modalId" 
                :isSaving="billingAddressModal.isSaving" 
                :showModal="billingAddressModal.showModal"
                @closeClicked="onBillingAddressModalCloseClick"
                @saveButtonClicked="onBillingAddressModalSaveButtonClicked">
        <template #form>
            <form>
                <div class="form-group">
                    <label for="companyInput">
                        Company
                    </label>
                    <div class="text-danger" v-if="billingAddressModal.billingAddress.siteName.hasError">
                        {{billingAddressModal.billingAddress.siteName.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="companyInput" v-model="billingAddressModal.billingAddress.siteName.value">
                </div>
                <div class="form-group">
                    <label for="streetAddressInput">
                        Street Address
                    </label>
                    <div class="text-danger" v-if="billingAddressModal.billingAddress.streetAddress.hasError">
                        {{billingAddressModal.billingAddress.streetAddress.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="streetAddressInput" v-model="billingAddressModal.billingAddress.streetAddress.value">
                </div>
                <div class="form-group">
                    <label for="cityInput">
                       City
                    </label>
                    <div class="text-danger" v-if="billingAddressModal.billingAddress.city.hasError">
                        {{billingAddressModal.billingAddress.city.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="cityInput" v-model="billingAddressModal.billingAddress.city.value">
                </div>
                <div class="form-group">
                    <label for="provinceSelect">
                       Province
                    </label>
                    <div class="text-danger" v-if="billingAddressModal.billingAddress.provinceId.hasError">
                        {{billingAddressModal.billingAddress.provinceId.errorMessage}}
                    </div>
                    <bootstrap-select :selectOptions="provinces" :selectedOption="billingAddressModal.billingAddress.provinceId.value" :elementId="'provinceSelect'"
                                    :returnSelectedOptionText="true"
                                    @changeSelect="onProvinceSelect"></bootstrap-select>
                </div>
                <div class="form-group">
                    <label for="postalCodeInput">
                       Postal Code
                    </label>
                    <div class="text-danger" v-if="billingAddressModal.billingAddress.postalCode.hasError">
                        {{billingAddressModal.billingAddress.postalCode.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="postalCodeInput" v-model="billingAddressModal.billingAddress.postalCode.value">
                </div>
                <div class="form-group">
                    <label for="vatNumberInput">
                       VAT Number
                    </label>
                    <div class="text-danger" v-if="billingAddressModal.billingAddress.vatNumber.hasError">
                        {{billingAddressModal.billingAddress.vatNumber.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="vatNumberInput" v-model="billingAddressModal.billingAddress.vatNumber.value">
                </div>
            </form>
        </template>
    </modal-form>

    <modal-form
            :heading="shippingAddressModal.heading" 
            :modalId="shippingAddressModal.modalId" 
            :isSaving="shippingAddressModal.isSaving" 
            :showModal="shippingAddressModal.showModal"
            @closeClicked="onShippingAddressModalCloseClick"
            @saveButtonClicked="onShippingAddressModalSaveButtonClicked">
        <template #form>
            <form>
                <h5>Contact Person</h5>
                <div class="form-group">
                    <label for="contactPersonFirstNameInput">
                        First Name
                    </label>
                    <div class="text-danger" v-if="shippingAddressModal.shippingAddress.contactPerson.firstName.hasError">
                        {{shippingAddressModal.shippingAddress.contactPerson.firstName.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="contactPersonFirstNameInput" v-model="shippingAddressModal.shippingAddress.contactPerson.firstName.value">
                </div>
                <div class="form-group">
                    <label for="contactPersonLastNameInput">
                        Last Name
                    </label>
                    <div class="text-danger" v-if="shippingAddressModal.shippingAddress.contactPerson.lastName.hasError">
                        {{shippingAddressModal.shippingAddress.contactPerson.lastName.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="contactPersonLastNameInput" v-model="shippingAddressModal.shippingAddress.contactPerson.lastName.value">
                </div>
                <div class="form-group">
                    <label for="contactPersonPhoneNumberInput">
                        Phone Number
                    </label>
                    <div class="text-danger" v-if="shippingAddressModal.shippingAddress.contactPerson.phoneNumber.hasError">
                        {{shippingAddressModal.shippingAddress.contactPerson.phoneNumber.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="contactPersonPhoneNumberInput" v-maska data-maska="### ### ####" v-model="shippingAddressModal.shippingAddress.contactPerson.phoneNumber.value">
                </div>
                <hr class="mb-5">
                <div class="form-group">
                    <label for="siteNameInput">
                        Site Name
                    </label>
                    <div class="text-danger" v-if="shippingAddressModal.shippingAddress.siteName.hasError">
                        {{shippingAddressModal.shippingAddress.siteName.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="siteNameInput" v-model="shippingAddressModal.shippingAddress.siteName.value">
                </div>
                <div class="form-group">
                    <label for="streetAddressShippingAddressInput">
                        Street Address
                    </label>
                    <div class="text-danger" v-if="shippingAddressModal.shippingAddress.streetAddress.hasError">
                        {{shippingAddressModal.shippingAddress.streetAddress.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="streetAddressShippingAddressInput" v-model="shippingAddressModal.shippingAddress.streetAddress.value">
                </div>
<!--                <div class="form-group">-->
<!--                    <label for="suburbInput">-->
<!--                        Suburb-->
<!--                    </label>-->
<!--                    <div class="text-danger" v-if="shippingAddressModal.shippingAddress.suburb.hasError">-->
<!--                        {{shippingAddressModal.shippingAddress.suburb.errorMessage}}-->
<!--                    </div>-->
<!--                    <input type="text" class="form-control" id="suburbInput" v-model="shippingAddressModal.shippingAddress.suburb.value">-->
<!--                </div>-->
                <div class="form-group">
                    <label for="cityShippingAddressInput">
                        City
                    </label>
                    <div class="text-danger" v-if="shippingAddressModal.shippingAddress.city.hasError">
                        {{shippingAddressModal.shippingAddress.city.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="cityShippingAddressInput" v-model="shippingAddressModal.shippingAddress.city.value">
                </div>
                <div class="form-group">
                    <label for="provinceShippingAddressSelect">
                        Province
                    </label>
                    <div class="text-danger" v-if="shippingAddressModal.shippingAddress.provinceId.hasError">
                        {{shippingAddressModal.shippingAddress.provinceId.errorMessage}}
                    </div>
                    <bootstrap-select :selectOptions="provinces" :selectedOption="shippingAddressModal.shippingAddress.provinceId.value" :elementId="'provinceShippingAddressSelect'"
                                    :returnSelectedOptionText="true"
                                    @changeSelect="onProvinceSelect($event, true)"></bootstrap-select>
                </div>
                <div class="form-group">
                    <label for="postalCodeShippingAddressInput">
                        Postal Code
                    </label>
                    <div class="text-danger" v-if="shippingAddressModal.shippingAddress.postalCode.hasError">
                        {{shippingAddressModal.shippingAddress.postalCode.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="postalCodeShippingAddressInput" v-model="shippingAddressModal.shippingAddress.postalCode.value">
                </div>
<!--                <div class="form-group">-->
<!--                    <label for="areaShippingAddressSelect">-->
<!--                        Area-->
<!--                    </label>-->
<!--                    <div class="text-danger" v-if="shippingAddressModal.shippingAddress.areaId.hasError">-->
<!--                        {{shippingAddressModal.shippingAddress.areaId.errorMessage}}-->
<!--                    </div>-->
<!--                    <bootstrap-select :selectOptions="shippingAreas" :selectedOption="shippingAddressModal.shippingAddress.areaId.value" :elementId="'areaShippingAddressSelect'"-->
<!--                                    :returnSelectedOptionText="true"-->
<!--                                    @changeSelect="onAreaSelect($event, true)"></bootstrap-select>-->
<!--                </div>-->
                <div class="form-group">
                    <label for="zoneShippingAddressSelect">
                        Zone
                    </label>
                    <div class="text-danger" v-if="shippingAddressModal.shippingAddress.zoneId.hasError">
                        {{shippingAddressModal.shippingAddress.zoneId.errorMessage}}
                    </div>
                    <bootstrap-select :selectOptions="shippingZones" :selectedOption="shippingAddressModal.shippingAddress.zoneId.value" :elementId="'zoneShippingAddressSelect'"
                                    :returnSelectedOptionText="true"
                                    @changeSelect="onZoneSelect($event, true)"></bootstrap-select>
                </div>
                <div class="form-group">
                    <label>
                        Site Coordinates
                    </label>
                    <div class="text-danger" v-if="shippingAddressModal.shippingAddress.gpsCoordinates.hasError">
                        {{shippingAddressModal.shippingAddress.gpsCoordinates.errorMessage}}
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <label>Latitude</label>
                            <div class="text-danger" v-if="shippingAddressModal.shippingAddress.latitude.hasError">
                                {{shippingAddressModal.shippingAddress.latitude.errorMessage}}
                            </div>
                            <input type="text" class="form-control" id="latitudeInput" v-model="shippingAddressModal.shippingAddress.latitude.value"/>
                        </div>
                        <div class="col-6">
                            <label>Longitude</label>
                            <div class="text-danger" v-if="shippingAddressModal.shippingAddress.longitude.hasError">
                                {{shippingAddressModal.shippingAddress.longitude.errorMessage}}
                            </div>
                            <input type="text" class="form-control" id="longitudeInput" v-model="shippingAddressModal.shippingAddress.longitude.value"/>
                        </div>
                    </div>
                </div>
            </form>
        </template>
    </modal-form>

    <mark-as-active-inactive-modal
            :heading="shippingAddressMarkAsActiveOrInactiveModal.heading"
            :modalId="shippingAddressMarkAsActiveOrInactiveModal.modalId"
            :isSaving="shippingAddressMarkAsActiveOrInactiveModal.isSaving"
            :showModal="shippingAddressMarkAsActiveOrInactiveModal.showModal"
            :isActive="shippingAddressMarkAsActiveOrInactiveModal.isActive"
            @closeClicked="shippingAddressMarkAsActiveOrInactiveModal.showModal = false"
            @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>
</div>
